module.exports = __webpack_public_path__ + "img/Poker_Chip_Yellow.cb1d3b31.svg";